import React from 'react';
import Client from './../Client';
import BackofficeReportsApi from './backofficeReportsApi';
import PromotionKpiCard from './PromotionKpiCard';

class OverviewSalesFromClaims extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      data: {},
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.periodMode !== this.props.periodMode) {
      this.loadData();
    }
  }

  getPeriodLabel = () => {
    const periodMode = this.props.periodMode || "last_30d";

    if (periodMode === "last_7d") return "last 7d";
    if (periodMode === "last_90d") return "last 90d";

    return "last 30d";
  };

  loadData = () => {
    const periodMode = this.props.periodMode || "last_30d";

    let queryData = {
      periodMode: periodMode,
    };

    let data = BackofficeReportsApi.getPromotionsKpiSummary(this.state.client, queryData);

    if (data) {
      this.setState({ data: data });
    }
  };

  render() {
    const data = this.state.data || {};

    const salesFromClaims = data.sales_from_claims || 0;
    const ordersWithClaims = data.orders_with_claims || 0;

    return (
      <PromotionKpiCard
        title="Promo sales"
        value={salesFromClaims}
        badge={`${ordersWithClaims} orders`}
        caption={this.getPeriodLabel()}
        change={data.sales_from_claims_change}
        isMoney
      />
    );
  }
}

export default OverviewSalesFromClaims;
